import createReducer from "./../createReducer";
import { handlersSelectableOptions } from "./handlers";

export default createReducer({ options: {}, disabled: false }, handlersSelectableOptions);
